import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import AppSettingsAltOutlinedIcon from "@mui/icons-material/AppSettingsAltOutlined";

import { useTranslation } from "react-i18next";
import { useContext } from "react";
import AppContext from "../../appContext";

export default function PairButton() {
  const { t } = useTranslation();
  const {
    app: { sessionId },
  } = useContext(AppContext);
  const addMyDevice = () =>
    (window.location = `${window.REACT_APP_ONBOARDING_ADDRESS}?pair=1&sessionId=${sessionId}`); // skip the mWhat video

  return (
    <ListItem
      button
      sx={{
        borderRadius: 1,
        width: "90%",
        margin: "auto",
      }}
      onClick={addMyDevice}
      color=""
    >
      <ListItemIcon>
        <Avatar>
          <AppSettingsAltOutlinedIcon />
        </Avatar>
      </ListItemIcon>
      <ListItemText
        primary={t("navigation.clients.linkPhone")}
        secondary={t("navigation.clients.previewSurveys")}
      />
    </ListItem>
  );
}
